var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2641",
    "data-name": "Rectangle 2641",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26475",
    "data-name": "Group 26475",
    transform: "translate(-166 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2642",
    "data-name": "Rectangle 2642",
    transform: "translate(166 444)",
    fill: "#1877f2",
    stroke: "#1877f2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.757,
    height: 19.757,
    rx: 9.878,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18.757,
    height: 18.757,
    rx: 9.378,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26474",
    "data-name": "Group 26474",
    transform: "translate(166 444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26473",
    "data-name": "Group 26473",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26472",
    "data-name": "Group 26472",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37717",
    "data-name": "Path 37717",
    d: "M16.619,15.176l.443-2.891H14.289V10.41a1.446,1.446,0,0,1,1.63-1.562H17.18V6.387a15.417,15.417,0,0,0-2.238-.195,3.529,3.529,0,0,0-3.777,3.89v2.2H8.625v2.891h2.539v6.781h3.125V15.176Z",
    transform: "translate(-2.726 -1.957)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a0371bf27f552e06e9c05ac647705ac7.svg";
export { ForwardRef as ReactComponent };